document.addEventListener('DOMContentLoaded', function () {
    const container = document.getElementById('es-nav-search-container');
    if (!container) return;

    const form = container.querySelector('#es-nav-search-form');
    const input = container.querySelector('#es-search-field');
    const resultsList = container.querySelector('#es-search-results-list');
    const statusRegion = container.querySelector('#es-search-status');

    // Extract endpoint from global scope, with a safe fallback
    const searchUrl = window.AppConfig?.navSearchUrl || '/nav-search';

    let debounceTimer;
    let activeIndex = -1;
    let currentItems = [];

    input.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        const query = this.value.trim();

        if (query.length < 3) {
            hideDropdown();
            return;
        }

        debounceTimer = setTimeout(() => {
            fetch(`${searchUrl}?q=${encodeURIComponent(query)}`, {
                headers: {'X-Requested-With': 'XMLHttpRequest'}
            })
                .then(res => res.json())
                .then(data => {
                    currentItems = data;
                    renderResults(data);
                })
                .catch(() => hideDropdown());
        }, 250);
    });

    // Keyboard Navigation Lifecycle
    input.addEventListener('keydown', function (e) {
        const items = resultsList.querySelectorAll('[role="option"]:not(.dropdown-disabled)');

        if (!items.length && currentItems.length === 0) return;

        if (e.key === 'ArrowDown') {
            e.preventDefault();
            if (!resultsList.classList.contains('display-none')) {
                activeIndex = (activeIndex + 1) % items.length;
                updateHighlight(items);
            }
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            if (!resultsList.classList.contains('display-none')) {
                activeIndex = (activeIndex - 1 + items.length) % items.length;
                updateHighlight(items);
            }
        } else if (e.key === 'Escape') {
            hideDropdown();
        }
    });

    form.addEventListener('submit', function (e) {
        e.preventDefault();
        const items = resultsList.querySelectorAll('[role="option"]:not(.dropdown-disabled)');
        if (activeIndex >= 0 && items[activeIndex]) {
            window.location.href = items[activeIndex].querySelector('a').href;
            return;
        }
        if (items.length > 0) {
            window.location.href = items[0].querySelector('a').href;
            return;
        }
    });

    function renderResults(items) {
        resultsList.innerHTML = '';
        activeIndex = -1;
        input.removeAttribute('aria-activedescendant');

        if (!items.length) {
            const li = document.createElement('li');
            li.className = 'padding-1-5 text-base-dark text-italic dropdown-disabled';
            li.setAttribute('role', 'option');
            li.setAttribute('aria-disabled', 'true');
            li.textContent = 'No results found';
            resultsList.appendChild(li);

            statusRegion.textContent = 'No results found.';
        } else {
            items.forEach((item, index) => {
                const li = document.createElement('li');
                li.className = 'cursor-pointer';
                li.setAttribute('role', 'option');
                li.setAttribute('id', `es-search-opt-${index}`);
                li.setAttribute('aria-selected', 'false');

                const anchor = document.createElement('a');
                anchor.href = item.url;
                anchor.className = 'text-no-underline text-base-darkest display-block width-full padding-1 hover:bg-base-lightest';
                anchor.textContent = item.title;

                li.appendChild(anchor);
                resultsList.appendChild(li);
            });

            statusRegion.textContent = `${items.length} results found. Use up and down arrows to review.`;
        }

        resultsList.classList.remove('display-none');
        input.setAttribute('aria-expanded', 'true');
    }

    function updateHighlight(items) {
        items.forEach((item, index) => {
            const anchor = item.querySelector('a');
            if (index === activeIndex) {
                item.setAttribute('aria-selected', 'true');
                anchor.classList.add('bg-primary-darker', 'text-white');
                anchor.classList.remove('hover:bg-base-lightest', 'text-base-darkest');
                input.setAttribute('aria-activedescendant', item.id);
                item.scrollIntoView({block: 'nearest'});
            } else {
                item.setAttribute('aria-selected', 'false');
                anchor.classList.remove('bg-primary-darker', 'text-white');
                anchor.classList.add('hover:bg-base-lightest', 'text-base-darkest');
            }
        });
    }

    function hideDropdown() {
        resultsList.innerHTML = '';
        resultsList.classList.add('display-none');
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
        activeIndex = -1;
        currentItems = [];
    }

    document.addEventListener('click', function (e) {
        if (!container.contains(e.target)) hideDropdown();
    });
});